import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

// Confirmación de "Cerrar compromiso" (kebab de Futuros, P1.10 redefinido, 8.1). Modal estándar de
// la plataforma en vez de window.confirm — mismo texto con el saldo que deja de proyectarse. No
// escribe DB por sí mismo: delega en onConfirm (el padre hace la RPC cerrar_compromiso + toast +
// patch puntual + cierre).

const fmtMonto = (n, moneda) => {
  const pref = moneda === "USD" ? "US$ " : moneda === "PEN" ? "S/ " : "$";
  return pref + Number(n || 0).toLocaleString("es-CL", { maximumFractionDigits: moneda === "USD" ? 2 : 0 });
};

const CerrarCompromisoModal = ({ show, onHide, entry, onConfirm }) => {
  const [guardando, setGuardando] = useState(false);

  if (!entry) return null;

  const saldoTxt = fmtMonto(entry.saldo_pendiente ?? entry.monto, entry.moneda);

  const handleConfirmar = async () => {
    setGuardando(true);
    try {
      await onConfirm(entry);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>Cerrar compromiso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontSize: "0.9rem", lineHeight: 1.7, marginBottom: 16 }}>
          <div>
            <strong>Concepto:</strong> {entry.razon_social_receptor || "—"}
          </div>
        </div>
        <div style={{ fontSize: "0.9rem" }}>
          El saldo pendiente de {saldoTxt} dejará de proyectarse en Por pagar. El historial de amortizaciones se
          conserva. ¿Cerrar este compromiso?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide} disabled={guardando}>
          Cancelar
        </Button>
        <Button variant="primary" size="sm" onClick={handleConfirmar} disabled={guardando}>
          {guardando ? "Guardando…" : "Cerrar compromiso"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CerrarCompromisoModal;
